import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const PROMOTIONS_NAMESPACE_TOKEN = new InjectionToken<string | Observable<string>>(
  '[Promotions]: token for namespace (e.g. accountGroupId)',
);

export interface PromotionsFlyerBranding {
  bgColor?: string;
  textColor?: string;
  logoUrl?: string;
}

export const PROMOTIONS_FLYER_BRANDING_TOKEN = new InjectionToken<Observable<PromotionsFlyerBranding>>(
  '[Promotions]: token for flyer branding (bgColor, textColor, logoUrl)',
);

export const PROMOTIONS_PARENT_NAMESPACE_TOKEN = new InjectionToken<string | Observable<string>>(
  '[Promotions]: token for parent namespace (empty if partner context, partnerId if SMB context)',
);

export const PROMOTIONS_COUNTRY_TOKEN = new InjectionToken<Observable<string | null>>(
  '[Promotions]: token for current business country name',
);
